import { render, staticRenderFns } from "./BussinessStatesManagement.vue?vue&type=template&id=bf633b1a&"
import script from "./bussiness-states-management.ts?vue&type=script&lang=ts&"
export * from "./bussiness-states-management.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports